import React, { useEffect } from 'react';
import { IDWALL_SDK_TOKEN, IDWALL_SDK_URL } from '@portal/config/env';

interface IdwallSDKProps {
  setToken: (token: string) => void;
}

const IdwallSDK = ({ setToken }: IdwallSDKProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = IDWALL_SDK_URL;
    script.async = true;

    script.onload = () => {
      window.idwSDKWeb({
        token: IDWALL_SDK_TOKEN,

        onComplete: ({ token }) => {
          setToken(token);
        },
      });
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [setToken]);

  return <div data-idw-sdk-web className="idwall_container"></div>;
};

export default IdwallSDK;
